// extracted by mini-css-extract-plugin
export default {"container":"Exposition_container__6yc61","top":"Exposition_top__GFEU5","nav":"Exposition_nav__HDfBo","exitBtn":"Exposition_exitBtn__NIdPz","name":"Exposition_name__CR+Td"};